import PropTypes from 'prop-types';
import {EntityIllustration} from 'front-onceforall-core';
import DossierStateCell from '../../../dossier/DossierStateCell';
import {getOrganisationLogoUrl} from '../../../../utils/organisation';

function ListItemView(props) {
  const {organisation} = props;

  return (
    <tr onClick={props.onClickOrganisation}>
      <td>
        <div
          data-id="organisationContainer"
          className="flex-container center"
        >
          <EntityIllustration
            country={organisation.country}
            name={organisation.fullName}
            imageUrl={getOrganisationLogoUrl(organisation.organisationId)}
            small
          />
          <span
            data-id="organisationName"
            className="ml-3"
          >
            {organisation.fullName}
          </span>
        </div>
      </td>
      <td data-id="registrationNumber">{organisation.registrationNumber}</td>
      <td data-id="postCode">{organisation.address.postCode}</td>
      <td data-id="city">{organisation.address.city}</td>
      <DossierStateCell
        data-id="dossierState"
        state={props.dossierState}
      />
    </tr>
  );
}

ListItemView.propTypes = {
  organisation: PropTypes.object.isRequired,
  onClickOrganisation: PropTypes.func.isRequired,
  dossierState: PropTypes.string
};

export default ListItemView;
